import GoogleOneTapTracker from 'components/shared/GoogleOneTapTracker/GoogleOneTapTracker';
import LoginOffering from 'shared/components/login_offering';

export default class LoginOfferingHelper {
  static googleOneTapNotification(notification) {
    GoogleOneTapTracker.sendEvent(notification);
    if(notification.isNotDisplayed()) {
      LoginOfferingHelper.showVidioOffer();
    }
  }

  static showLoginOffer() {
    let google_offer = document.querySelector('#g_id_onload');
    if(google_offer) {
      LoginOfferingHelper.showGoogleOffer();
    } else {
      LoginOfferingHelper.showVidioOffer();
    }
  }

  static showGoogleOffer() {
    var scriptTag = document.createElement('script');
    scriptTag.src = "https://accounts.google.com/gsi/client";
    document.body.appendChild(scriptTag);
  }

  static showVidioOffer() {
    (new LoginOffering()).show();
  }
}
